export const fonts = {
    heading: "Poppins",
    body: "Inter",
}
